import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import { TOGGLE_NEW_MODAL } from '@/constants/detail';
import VMask from './VMask';
export default {
  name: 'widget_new_modal',
  components: {
    'v-mask': VMask
  },
  props: {
    close: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: true
    }
  },
  methods: Object.assign({}, mapActions([TOGGLE_NEW_MODAL]))
};